import axios from "@/utils/axios.js";

/**
 * Получение списка карт
 */
function getCards(perPage, currentPage, sort, search) {
    return new Promise((resolve, reject) => {
        axios
            .get(`card?expand=user&sort=${sort}${search ? `&search[All]=${search}` : ''}&per-page=${perPage}&page=${currentPage}`)
            .then((res) => {
                resolve(res.data);
            })
            .catch((err) => {
                reject(err);
            });
    });
}

/**
 * Получение карты
 */
function getCard(id) {
    return new Promise((resolve, reject) => {
        axios
            .get(`card/${id}?expand=user`)
            .then((res) => {
                resolve(res.data);
            })
            .catch((err) => {
                reject(err);
            });
    });
}

/**
 * Получение карт пользователя
 */
function getUserCard(id) {
  return new Promise((resolve, reject) => {
      axios
          .get(`card?search[UserId]=${id}`)
          .then((res) => {
              resolve(res.data);
          })
          .catch((err) => {
              reject(err);
          });
  });
}

/**
 * Создание карты
 * @param {String} card_number
 * @param {Number} user_id
 * @param {String} transporter
 */
function createCard(
    card_number,
    user_id,
    transporter
) {
    const cardData = {
      card_number,
      user_id,
      transporter
    };

    return new Promise((resolve, reject) => {
        axios
            .post("card", cardData)
            .then((res) => {
                resolve(res.data);
            })
            .catch((err) => {
                reject(err);
            });
    });
}

/**
 * Удаление карт
 */
function deleteCards(ids) {
    return new Promise((resolve, reject) => {
        axios
            .delete(`card`, { data: { loyalty_cards: ids } })
            .then((res) => {
                resolve(res.data);
            })
            .catch((err) => {
                reject(err);
            });
    });
}

/**
 * Восстановление карт
 */
function restoreCard(id) {
    return new Promise((resolve, reject) => {
        axios
            .post(`card/${id}/restore`)
            .then((res) => {
                resolve(res.data);
            })
            .catch((err) => {
                reject(err);
            });
    });
}

/**
 * Редактирование карт
 * @param {Number} id
 * @param {Number} card_number
 * @param {String} user_id
 * @param {String} transporter
 */
function updateCard(
    id,
    card_number,
    user_id,
    transporter
) {
    const cardData = {
      card_number,
      user_id,
      transporter
    };

    return new Promise((resolve, reject) => {
        axios
            .put(`card/${id}`, cardData)
            .then((res) => {
                resolve(res.data);
            })
            .catch((err) => {
                reject(err);
            });
    });
}

export {
    getCards,
    getCard,
    getUserCard,
    createCard,
    deleteCards,
    restoreCard,
    updateCard,
}